import {Component, Module} from 'app/decorators';
import _ from 'lodash';
import BasePicker from 'app/directives/base.picker';
import CompanyPicker from 'app/directives/company.picker';

import tpl from './companies.component.tpl.html';


@Module({
    name: "app.directives.companies.component",
    modules: [
        CompanyPicker,
    ]
})
@Component({
    selector: 'blnd-companies',
    bindings: {
        ngModel: '=',
        mode: '@?',
    },
    template: tpl,
})
export default class C extends BasePicker {
    constructor (CompanyStore, $element) {
        "ngInject";
        super($element);
        this.mode = this.mode || 'view';
        this.store = CompanyStore;
        this.store.init();
        this.items = [];
    }

    refresh (search) {
        let self = this;

        if (!this.enabled) { return; }
        this.store.params.search = search;
        this.store.refresh().then(function (obj) {
            self.items = _.map(obj.list, (o) => {
                return {
                    id: o.id,
                    name: o.name,
                };
            });
         });
    }

    $onDestroy () {
        this.items = [];
        super.$onDestroy();
    }

}



// WEBPACK FOOTER //
// ./src/app/directives/companies.component.js